var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ready && _vm.visible)?_c('a',{attrs:{"href":_vm.safeUrl,"download":_vm.safeFileName,"target":_vm.target}},[_vm._v(" Download "+_vm._s(_vm.safeFileName)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }